import { BaseReportHandler } from "./BaseReportHandler";
import { ExcelBuilder } from "../utils/ExcelBuilder";
import { PdfBuilder } from "../utils/PdfBuilder";

export class TrialBalanceHandler extends BaseReportHandler {
    
    getColumns(isSnapshot) {
        if (isSnapshot) {
            return {
                headers: ['Cuenta', 'Nombre Cuenta', 'NIT/CC', 'Tercero / Concepto', 'Saldo Final'],
                keys: ['codigo_cuenta', 'account_name', 'identificacion', 'nombre', 'saldo_final']
            };
        }
        return {
            headers: ['Cuenta', 'Nombre Cuenta', 'NIT/CC', 'Tercero / Concepto', 'Saldo Anterior', 'Mov. Débito', 'Mov. Crédito', 'Saldo Final'],
            keys: ['codigo_cuenta', 'account_name', 'identificacion', 'nombre', 'saldo_anterior', 'periodo_debito', 'periodo_credito', 'saldo_final']
        };
    }

    formatRow(item, keys) {
        return keys.map(k => {
            if (k === 'account_name') {
                return item.auxiliar_name || item.account_name || item.auxiliary_name || item.description || (item.is_third ? '' : item.nombre);
            }
            if (k === 'nombre') {
                return item.is_third ? item.nombre : (item.auxiliar_name || item.account_name || item.auxiliary_name || item.description ? '' : item.nombre);
            }
            return item[k] ?? "";
        });
    }

    async downloadExcel() {
        const builder = new ExcelBuilder(this.metadata);
        builder.addMainHeader();

        const isSnapshot = this.metadata.is_snapshot === true;
        const { headers, keys } = this.getColumns(isSnapshot);

        const rows = this.sections[0]?.data || [];
        const formattedRows = rows.map(item => this.formatRow(item, keys));
        const currencyKeys = ['saldo_anterior', 'periodo_debito', 'periodo_credito', 'saldo_final'];
        const currencyIndices = keys.map((k, i) => currencyKeys.includes(k) ? i : -1).filter(i => i !== -1);

        builder.addTable(headers, formattedRows, {
            onRowAdded: (excelRow, rawValues) => {
                const rowIndex = formattedRows.indexOf(rawValues);
                const item = rows[rowIndex];
                
                excelRow.eachCell((cell, colNumber) => {
                    const key = keys[colNumber - 1];
                    const isCurrency = currencyKeys.includes(key);

                    if (isCurrency && typeof cell.value === 'number') {
                        cell.numFmt = '"$"#,##0;[Red]"-"$#,##0';
                        cell.alignment = { horizontal: "right" };
                    }
                    
                    if (item.level !== undefined && item.level <= 2) {
                        cell.font = { bold: true };
                    }
                });
            }
        });

        // Totals row
        if (this.data.totals) {
            const t = this.data.totals;
            const totalsRow = isSnapshot 
                ? ["", "SUMAS IGUALES", "", "", t.saldo_fin]
                : ["", "SUMAS IGUALES", "", "", t.saldo_ant, t.per_deb, t.per_cre, t.saldo_fin];
            
            builder.addTotalsRow(totalsRow, currencyIndices);
        }

        await builder.download();
    }

    async downloadPdf(download = true) {
        const builder = new PdfBuilder(this.metadata);
        builder.setOrientation("landscape");
        builder.addMainHeader();

        const isSnapshot = this.metadata.is_snapshot === true;
        const { headers, keys } = this.getColumns(isSnapshot);
        const rows = this.sections[0]?.data || [];
        const currencyKeys = ['saldo_anterior', 'periodo_debito', 'periodo_credito', 'saldo_final'];
        const currencyIndices = keys.map((k, i) => currencyKeys.includes(k) ? i : -1).filter(i => i !== -1);

        const bodyRows = rows.map(item => {
            const values = this.formatRow(item, keys);
            return values.map((val, i) => {
                const key = keys[i];
                const isCurrency = currencyKeys.includes(key);
                return {
                    text: isCurrency ? builder.formatCurrency(val) : builder.formatGeneralValue(val),
                    alignment: isCurrency ? "right" : "left",
                    color: (isCurrency && val < 0) ? 'red' : 'black',
                    noWrap: isCurrency,
                    bold: item.level !== undefined && item.level <= 2
                };
            });
        });

        if (this.data.totals) {
            const t = this.data.totals;
            const totalsRow = isSnapshot 
                ? ["", "SUMAS IGUALES", "", "", t.saldo_fin]
                : ["", "SUMAS IGUALES", "", "", t.saldo_ant, t.per_deb, t.per_cre, t.saldo_fin];
            
            bodyRows.push(builder.getTotalsRow(totalsRow, currencyIndices));
        }

        builder.addTable(headers, bodyRows, {
            widths: headers.map((_, i) => (i === 1 || i === 3) ? "*" : "auto")
        });

        return builder.download(download);
    }
}
